export const fontCdn: string =
  "https://fonts.googleapis.com/css2?family=Libre+Baskerville&family=Raleway:wght@400;700&display=swap";

export const headlineFont: string = `'Raleway', sans-serif`;
export const bodyFont: string = `'Libre Baskerville', serif`;
export const fontFamilies = [headlineFont, bodyFont];
